import Breadcrumb from '../Component/Breadcrumb'
const Ptm = () => {
    return (
        <>
            <Breadcrumb breadtitle="Attendance, Leave & Absence" breadmid="Admission" breadend="Attendance, Leave & Absence" />
            <div className="innerpage">
                <div className="container">
                    <div className="row">

                        <div class="col-12">

                            <div class="col-12">
                                <div class="media">
                                    <div class="media-body">
                                        <p>1. 75% attendance is required for the promotion of a student.</p>
                                    </div>
                                </div>
                                <div class="media">
                                    <div class="media-body">
                                        <p>2. Students will not leave the school campus during school hours without written permission from the
                                            Principal, which will be granted on the written application of the parents.</p>
                                    </div>
                                </div>
                                <div class="media">
                                    <div class="media-body">
                                        <p>3. The Students who are irowegular in class attendance due to feasts, celebrations, visits to
                                            relatives, marowiages trips etc. will be asked to discontinue.</p>
                                    </div>
                                </div>
                                <div class="media">
                                    <div class="media-body">
                                        <p>4. No leave of absence for the whole day or a part of the day will be granted except for serious
                                            reasons and prior written application by the parents. </p>
                                    </div>
                                </div>
                                <div class="media">
                                    <div class="media-body">
                                        <p>5. Vacations will not be extended without prior information and written application. The students who
                                            extend their vacation for more than a week without sanctioned leave will have their names struck off the
                                            School Register.</p>
                                    </div>
                                </div>
                                <div class="media">
                                    <div class="media-body">
                                        <p>6. Medical leave for more than 3 days will be granted if the application is accompanied by a proper and
                                            authorized Medical certificate by a doctor.</p>
                                    </div>
                                </div>
                                <div class="media">
                                    <div class="media-body">
                                        <p>7. If a student remains absent for more than 10 days without any sanctioned leave, her name will be
                                            struck off the register and she will be readmitted with the whole admission process, with full Admission
                                            Fees and other full fees.</p>
                                    </div>
                                </div>
                                <div class="media">
                                    <div class="media-body">
                                        <p>8. Leave notes or leave applications should be signed by the parents or guardian. Without these the
                                            students will not be admitted to class.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Ptm